export default __webpack_public_path__ + "static/media/file.85316998.svg";